
import { mapGetters } from 'vuex'
export default {
	name: 'app',
	data() {
		return {
			andUrl: '',
			logoSrc: '',
			logo: '',
			showQr: false
		}
	},
	head() {
		return {
			title: '盼之代售官方APP下载-盼之代售-手游网游账号买号卖号平台',
			meta: [
				{
					hid: 'description',
					name: 'description',
					content: '盼之代售APP是专业游戏账号交易平台，为用户提供各种游戏账号交易服务，下载盼之代售APP方便用户实时查看账号交易相关。'
				},
				{
					hid: 'keywords',
					name: 'keywords',
					content: '盼之代售APP，盼之代售安卓APP，盼之代售软件'
				}
			]
		}
	},
	computed: {
		...mapGetters({ config: 'config' })
	},
	methods: {
		// 创建二维码
		crateQrcode(qrCodeUrl) {
			const pzfrom = this.$cookies.get('pzfrom')
			const bdVid = this.$cookies.get('bdVid')
			const qhClickId = this.$cookies.get('qhClickId')
			const markId = this.$cookies.get('markId')
			this.logoSrc = `${qrCodeUrl}?${pzfrom ? `pzfrom=${pzfrom}` : ''}${bdVid ? `&bd_vid=${bdVid}` : ''}${qhClickId ? `&qhclickid=${qhClickId}` : ''}${markId ? `&mark_id=${markId}` : ''}`
		},
		/**
		 * app下载页面
		 * @param type
		 */
		getAppUrl(type) {
			const appUrl = this.$store.getters.config[this.$enum.CONFIG.config_8]
			if (!appUrl) {
				this.$store.dispatch('AppPublicConfig').then(res => {
					this.andUrl = res[this.$enum.CONFIG.config_8]
					if (this.andUrl) {
						this.$nextTick(() => {
                            console.log(res[this.$enum.CONFIG.config_8]);

							this.crateQrcode(res[this.$enum.CONFIG.config_8])
						})
					}
				})
				return
			}
			this.andUrl = appUrl
			this.$nextTick(() => {
				this.crateQrcode(appUrl)
			})
		},
		getBase64Image(img) {
			var canvas = document.createElement('canvas')
			canvas.width = img.width
			canvas.height = img.height
			var ctx = canvas.getContext('2d')
			ctx.drawImage(img, '', '', img.width, img.height)
			var dataURL = canvas.toDataURL('image/png') // 可选其他值 image/jpeg
			return dataURL
		},

		mainIGM(src, cb) {
			let _this = this
			var image = new Image()
			image.src = src + '?v=' + Math.random() // 处理缓存
			image.crossOrigin = '*' // 支持跨域图片
			image.onload = function () {
				var base64 = _this.getBase64Image(image)
				cb && cb(base64)
			}
		}
	},
	async mounted() {
		this.mainIGM('https://oss.pzds.com/imgv2/qr-icon.png', res => {
			this.logo = res
			this.showQr = true
            
		})
        console.log(this.config,'------------=');

		if (this.config.config_8) {
			this.$nextTick(() => {
				this.crateQrcode(this.config.config_13)
			})
		} else {
			await this.$store.dispatch('AppPublicConfig')

			this.$nextTick(() => {
				this.crateQrcode(this.config.config_13)
			})
		}
		// this.getAppUrl();
	}
}
